import { reactive, onServerPrefetch, ref } from 'vue'
import { defineStore, storeToRefs } from 'pinia'
import { useRpcapi } from '~vueutil/pinia.js'

const name = 'notification'

const useStore = defineStore(name, () => {
  const rpcapi = useRpcapi()
  const loading = ref(false)
  const items = ref([])
  const stat = reactive({
    latestTotalCount: 0,
    unreadCount: 0,
    cursor: ''
  })

  async function fetchData () {
    const result = await rpcapi.getNotificationStat()
    if (!result) {
      return
    }

    return Object.assign(stat, result)
  }

  onServerPrefetch(async () => {
    await fetchData()
  })

  function isEnd () {
    return !stat.cursor
  }

  async function next () {
    stat.unreadCount = 0
    loading.value = true

    try {
      if (isEnd()) {
        return
      }

      const params = {
        cursor: stat.cursor
      }

      if (items.value.length === 0) {
        params.latestTotalCount = stat.latestTotalCount
      }

      const result = await rpcapi.takeNotification(params)

      if (!result.cursor) {
        stat.cursor = ''
        return
      }

      stat.cursor = result.cursor
      items.value.push(...result.items)
    } finally {
      loading.value = false
    }
  }

  function go (item) {
    const { eventSid } = item
    if (eventSid) {
      window.location.href = '/event/' + item.eventSid
    }
  }

  async function click (item) {
    if (!item.unread) {
      go(item)
      return
    }
    delete item.unread
    await rpcapi.readNotification({
      id: item.id
    })

    go(item)
  }

  return {
    loading,
    items,
    stat,
    next,
    click
  }
})

export function useNotificationStore () {
  const store = useStore()
  const { next, click } = store
  const {
    loading,
    items,
    stat
  } = storeToRefs(store)
  return {
    next,
    click,
    loading,
    items,
    stat
  }
}
